import { Link } from "react-router-dom";
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
    AccordionItemState,
} from "react-accessible-accordion";
import { FaAngleDown, FaAngleUp, FaRegArrowAltCircleRight } from "react-icons/fa";
import { useDownloadAppModal } from "../../context/DownloadAppModalContext";

const FAQ_ITEMS = [
    {
        question: "What is AfriPay?",
        answer:
            "AfriPay is an innovative platform simplifying international tuition payments, securing educational loans, and offering a digital wallet feature for seamless financial transactions.",
    },
    {
        question: "How does AfriPay simplify tuition payments?",
        answer:
            "AfriPay streamlines the tuition payment process, providing a user-friendly interface and multiple payment options for efficient and secure transactions.",
    },
    {
        question: "What security measures does AfriPay have in place?",
        answer:
            "AfriPay employs cutting-edge encryption technologies to ensure the security and confidentiality of user data, providing a safe environment for financial transactions.",
    },
    {
        question: "What is the digital wallet feature in AfriPay?",
        answer:
            "The digital wallet feature allows users to conveniently manage and access funds, enabling cashless transactions, budgeting, and automated savings.",
    },
    {
        question: "How does AfriPay support educational loans?",
        answer:
            "AfriPay assists users in securing educational loans, streamlining the application process, and providing transparent terms for quick approvals.",
    },
];

const ChevronIcon = ({ expanded }: { expanded: boolean }) => (
    <span className="w-7 h-7 rounded-full flex items-center justify-center border border-[#E7E8E9] shadow-sm">
        {expanded ? <FaAngleUp color="#637381" size={16} /> : <FaAngleDown color="#637381" size={16} />}
    </span>
);

export default function FaqSection() {
    const { openDownloadModal } = useDownloadAppModal();

    return (
        <section className="w-full px-4 pt-8 md:pt-10 pb-8 md:pb-10">
            <div className="max-w-7xl mx-auto">
                <div className="w-full flex flex-col md:flex-row items-start md:items-end justify-between mb-6 font-display-fran">
                    <div className="flex flex-col text-left gap-3 mb-4 md:mb-0">
                        <h2 className="font-display-fran font-semibold text-[#030319] text-[22px] md:text-3xl leading-[1.1] tracking-[-0.02em]">
                            Everything You Need to Know
                        </h2>
                        <p className="text-[#344054] text-[13px] md:text-sm">Discover how AfriPay works and what makes us different</p>
                    </div>
                    <Link
                        to="/faq"
                        className="text-[#024529] flex items-center justify-center gap-1.5 cursor-pointer transition-all duration-300 hover:text-gray-600"
                    >
                        View All <FaRegArrowAltCircleRight />
                    </Link>
                </div>

                <div className="mt-6 md:mt-8">
                    <div className="lg:col-span-8 col-span-12">
                        <Accordion allowZeroExpanded allowMultipleExpanded>
                            {FAQ_ITEMS.map(({ question, answer }) => (
                                <AccordionItem key={question} className="border border-[#FFFFFF12] overflow-hidden shadow-md rounded-lg mb-4">
                                    <AccordionItemHeading>
                                        <AccordionItemState>
                                            {({ expanded }) => (
                                                <AccordionItemButton
                                                    className="py-4 px-4 text-base sm:text-lg text-[#0a0a0a] font-display font-semibold flex items-center justify-between focus:outline-none focus:ring-offset-2"
                                                    aria-expanded={expanded}
                                                >
                                                    <span>{question}</span>
                                                    <ChevronIcon expanded={!!expanded} />
                                                </AccordionItemButton>
                                            )}
                                        </AccordionItemState>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel className="pb-6 px-4 text-xs sm:text-sm text-[#101828CC] font-body font-medium leading-relaxed">
                                        <p className="max-w-full">{answer}</p>
                                    </AccordionItemPanel>
                                </AccordionItem>
                            ))}
                        </Accordion>
                    </div>
                </div>

                <div className="w-full flex justify-center pt-4">
                    <button
                        type="button"
                        onClick={openDownloadModal}
                        className="w-[174px] h-13 rounded-lg bg-[#0B7F47] border-2 border-[#7FBC51] shadow-sm text-white text-sm p-3.5 cursor-pointer transition-colors duration-300 hover:bg-[#0B7F47]/60"
                    >
                        Get started — it's free
                    </button>
                </div>
            </div>
        </section>
    );
}